import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';

import { appShell } from '@savgroup-front-common/core/src/helpers';
import { generateUserManager } from '@savgroup-front-common/core/src/services/userManager';

import { unregisterServiceWorkersInDev } from './dev/unregisterServiceWorkers';
import AuthConfig from './configuration/auth/Auth.config';
import App from './view/app/App';

if (![].at) {
  Array.prototype.at = function (pos) {
    return this.slice(pos, pos + 1)[0];
  };
}

const userManager = generateUserManager(AuthConfig);

void unregisterServiceWorkersInDev().then(() => {
  void appShell({
    userManager,
    render: () => {
    const container = document.getElementById('root');

    if (!container) {
      throw new Error('Container not found. Please check your HTML code.');
    }

    const root = createRoot(container);

    root.render(
      <AuthProvider userManager={userManager}>
        <App />
      </AuthProvider>,
    );
    },
  });
});
